import fetch   from 'cross-fetch';
import numeral from 'numeral';

export const CHANGE_PARAMETER = 'CHANGE_PARAMETER';
export const CHANGE_PARAMETER_SUCESS = 'CHANGE_PARAMETER_SUCESS';

export const QUICK_QUOTE_REQUEST = 'QUICK_QUOTE_REQUEST';
export const QUOTE_REQUEST = 'QUOTE_REQUEST';
export const QUOTE_SUCCESS = 'QUOTE_SUCCESS';
export const QUOTE_FAILURE = 'QUOTE_FAILURE';

export const SELECT_PRICE_REQUEST = 'SELECT_PRICE_REQUEST';
export const SELECT_PRICE_SUCCESS = 'SELECT_PRICE_SUCCESS';
export const SELECT_PRICE_FAILURE = 'SELECT_PRICE_FAILURE';

export const LOAD_QUOTE_REQUEST = 'LOAD_QUOTE_REQUEST';
export const LOAD_QUOTE_SUCCESS = 'LOAD_QUOTE_SUCCESS';
export const LOAD_QUOTE_FAILURE = 'LOAD_QUOTE_FAILURE';

// export const SHOW_EMAIL_FORM = 'SHOW_EMAIL_FORM';
export const EMAIL_QUOTE_REQUEST = 'EMAIL_QUOTE_REQUEST';
export const EMAIL_QUOTE_SUCCESS = 'EMAIL_QUOTE_SUCCESS';
export const EMAIL_QUOTE_FAILURE = 'EMAIL_QUOTE_FAILURE';

export const CUSTOM_QUOTE_ASK = 'CUSTOM_QUOTE_ASK';
export const CUSTOM_QUOTE_REQUEST = 'CUSTOM_QUOTE_REQUEST';
export const CUSTOM_QUOTE_CANCEL = 'CUSTOM_QUOTE_CANCEL';
export const CUSTOM_QUOTE_SUCCESS = 'CUSTOM_QUOTE_SUCCESS';
export const CUSTOM_QUOTE_FAILURE = 'CUSTOM_QUOTE_FAILURE';

export const changeParameter = (name, value) => (
  {
    type: CHANGE_PARAMETER,
    name,
    value,
  }
);

export const changeParameterSucess = (name, value) => (
  {
    type: CHANGE_PARAMETER_SUCESS,
    name,
    value,
  }
);

export const quoteRequest = () => ({ type: QUOTE_REQUEST });

export const quoteSuccess = quote => ({ type: QUOTE_SUCCESS, quote });

export const quoteFailure = () => ({ type: QUOTE_FAILURE });

export const selectPriceRequest = () => ({ type: SELECT_PRICE_REQUEST });

export const selectPriceSuccess = selectedPrice => (
  {
    type: SELECT_PRICE_SUCCESS,
    selectedPrice,
  }
);

export const selectPriceFailure = () => ({ type: SELECT_PRICE_FAILURE });

export const customQuoteAsk = () => ({ type: CUSTOM_QUOTE_ASK });

export const customQuoteRequest = () => ({ type: CUSTOM_QUOTE_REQUEST });

export const customQuoteCancel = () => ({ type: CUSTOM_QUOTE_CANCEL })

export const customQuoteSuccess = () => ({ type: CUSTOM_QUOTE_SUCCESS });

export const customQuoteFailure = () => ({ type: CUSTOM_QUOTE_FAILURE });

export const onChangeParameter = (name, value) => dispatch => (
  dispatch(changeParameter(name, value))
);

export const onQuoteRequest = (parameters, token, variant, quoteNumber) => (dispatch) => {
  dispatch(quoteRequest());

  let urlQuote = Spree.routes.product_quote_url;
  let methodQuote = 'POST';
  if (quoteNumber && quoteNumber !== '') {
    urlQuote += `/${quoteNumber}`;
    methodQuote = 'PUT';
  }

  fetch(urlQuote, {
    method : methodQuote,
    headers: {
      Accept        : 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      parameters,
      authenticity_token: token,
      variant_id        : variant,
    }),
  }).then((res) => {
    if (res.status >= 400) {
      dispatch(quoteFailure());
    } else {
      return res.json();
    }
  }).then((quote) => {
    if (quote) {
      dispatch(quoteSuccess(quote));
    }
  }).catch((err) => {
    console.error(err);
    dispatch(quoteFailure());
  });
};

export const onPriceSelect = selectedPrice => (dispatch) => {
  if (selectedPrice.parametersChanged === true) {
    vfShowModalErrors('One or more parameters have changed. Please get a new quote');
    return;
  }

  // update cart
  // const cart = '.inside-product-cart';
  // const { quantity, unitPrice } = selectedPrice;
  // jQuery('.product-qty', cart).text(quantity);
  // jQuery('.product-lead-time', cart).text(selectedPrice.leadTime);
  // jQuery('.product-unit-price', cart).text(numeral(unitPrice).format('0.00'));
  // jQuery('.product-total', cart).text(numeral(unitPrice * quantity).format('0.00'));

  dispatch(selectPriceSuccess(selectedPrice));
};

export const onSendEmailQuote = (sendData, token) => (dispatch) => {
  const data = sendData;
  data.authenticity_token = token;

  fetch(Spree.routes.product_quote_email_url, {
    method : 'POST',
    headers: {
      Accept        : 'application/json',
      'Content-Type': 'application/json',
    },
    body   : JSON.stringify(data),
  }).then((res) => {
    if (res.status >= 400) {
      // dispatch(quoteFailure());
    }
    return res;
  }).catch((err) => {
    console.error(err);
    // dispatch(quoteFailure());
  });
};

export const onCustomQuoteAsk = () => dispatch => (
  dispatch(customQuoteAsk())
);

export const onCustomQuoteRequest = () => dispatch => (
  dispatch(customQuoteRequest())
);

export const onCustomQuoteCancel = () => dispatch => (
  dispatch(customQuoteCancel())
);
